import { render, staticRenderFns } from "./AllRtcs.vue?vue&type=template&id=36ce7851&scoped=true"
import script from "./AllRtcs.vue?vue&type=script&lang=js"
export * from "./AllRtcs.vue?vue&type=script&lang=js"
import style0 from "./AllRtcs.vue?vue&type=style&index=0&id=36ce7851&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce7851",
  null
  
)

export default component.exports